export default "__VITE_ASSET__DKIcnBz9__"